import { useSelector } from "react-redux";
import { AppState, IUserContext } from "../types";

export default function useUserContext(): IUserContext {
  return useSelector((state: AppState) => state.userContext);
}
